module.exports = __webpack_public_path__ + "06_hair_silver.a62f98cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/06_hair_silver.png
// module id = wIEP
// module chunks = 0